import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";

import {
  UserProvider,
  UserContext,
} from "./components/0. Header/UserContext";
import Layout from "./Layout"; //Header

//Pages
import HomePage from "./pages/0. HomePage/HomePage";
import FeedPage from "./pages/0. HomePage/FeedPage";
import NotFoundPage from "./pages/0. HomePage/NotFoundPage";
import RecopiladorPage from "./pages/0. HomePage/RecopiladorPage";
import RecopiladorPracticaTsPage from "./pages/0. HomePage/RecopiladorPracticaTsPage";
import MobileHomePrototypePage from "./pages/0. HomePage/MobileHomePrototypePage";

import MaestrasPage from "./pages/1. Gestión de Comunidades/MaestrasPage";
import CursosPage from "./pages/1. Gestión de Comunidades/CursosPage";
import ActividadesPage from "./pages/1. Gestión de Comunidades/ActividadesPage";
import ComentariosPage from "./pages/1. Gestión de Comunidades/ComentariosPage";
import SolicitudesPage from "./pages/1. Gestión de Comunidades/SolicitudesPage";
import CumpleañosPage from "./pages/1. Gestión de Comunidades/CumpleañosPage";
import WhatsappPage from "./pages/1. Gestión de Comunidades/WhatsappPage";

import PostulantesPage from "./pages/2. Módulo de Selección/PostulantesPage";
import ProcesosPage from "./pages/2. Módulo de Selección/ProcesosPage";
import ProcesosEsperaPage from "./pages/2. Módulo de Selección/EsperaPage";
import ProcesoMaestrasPage from "./pages/2. Módulo de Selección/ProcesoMaestrasPage";
import ResumenPage from "./pages/2. Módulo de Selección/ResumenPage";

const AppLayout = ({
  children,
  blockedRoles = [],
  redirectTo = null,
}) => {
  const { roles, isLoading } = useContext(UserContext);

  const hasBlockedRole = roles.some((role) => blockedRoles.includes(role));

  if (isLoading) {
    return <Layout />;
  }

  if (hasBlockedRole && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Layout>
      {hasBlockedRole ? null : children}
    </Layout>
  );
};

const BLOCK_RECOPILADOR = {
  blockedRoles: ["Recopilador/a"],
  redirectTo: "/recopilador",
};

const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Intranet Home */}
          <Route
            path="/"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <HomePage />
              </AppLayout>
            }
          />
          <Route
            path="recopilador"
            element={
              <AppLayout>
                <RecopiladorPage />
              </AppLayout>
            }
          />
          <Route
            path="recopilador/practica-ts"
            element={
              <AppLayout>
                <RecopiladorPracticaTsPage />
              </AppLayout>
            }
          />
          <Route
            path="feed"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <FeedPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Gestión de Comunidades */}
          {/* Maestras */}
          <Route
            path="todas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="todas/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="comunidad"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="comunidad/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras_externas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras_externas/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="alumna"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="alumna/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="especial"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="especial/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_maestras/" />
          <Route path="api/perfiles/editar_maestras/:rut/" />
          {/* Cursos */}
          <Route
            path="cursos"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CursosPage />
              </AppLayout>
            }
          />
          <Route
            path="cursos/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CursosPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_cursos/" />
          <Route path="api/perfiles/editar_cursos/:id/" />
          {/* Actividades */}
          <Route
            path="actividades"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ActividadesPage />
              </AppLayout>
            }
          />
          <Route
            path="actividades/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ActividadesPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_actividades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/editar_actividades/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Comentarios */}
          <Route
            path="comentarios"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ComentariosPage />
              </AppLayout>
            }
          />
          {/* Solicitudes */}
          <Route
            path="solicitudes"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <SolicitudesPage />
              </AppLayout>
            }
          />
          <Route path="api/formularios/ver_maestra/:rut/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Cumpleaños */}
          <Route
            path="cumpleaños"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CumpleañosPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Módulo de Selección */}
          {/* Postulaciones */}
          <Route path="api/seleccion/agregar_postulante_proceso/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Entrevista */}
          <Route
            path="postulantes"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <PostulantesPage />
              </AppLayout>
            }
          />
          <Route path="api/seleccion/editar_postulante_entrevista/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Psicoanalisis */}
          <Route
            path="procesos"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesosPage />
              </AppLayout>
            }
          />
          <Route
            path="espera"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesosEsperaPage />
              </AppLayout>
            }
          />
          <Route
            path="proceso_maestras"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesoMaestrasPage />
              </AppLayout>
            }
          />
          <Route path="api/seleccion/editar_postulante_psicoanalisis/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Historial */}
          <Route
            path="resumen"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ResumenPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Otros */}
          {/* Whatsapp */}
          <Route
            path="whatsapp"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <WhatsappPage />
              </AppLayout>
            }
          />
          <Route
            path="prototipo-home-mobile"
            element={<MobileHomePrototypePage />}
          />
          {/* Admin */}
          <Route path="admin/" />
          <Route path="api/perfiles/maestras/?excel=true" />
          <Route path="api/generar_qr/" />
          {/* Public */}
          <Route path="api/formularios/agregar_comunidades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_comunidades/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Catch-all route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
